export const csvToArray = (csv: string): string[] =>
    csv ? csv.split(",").map(s => s.trim()).filter(Boolean) : [];

export const arrayToCsv = (arr: string[]): string =>
    arr.filter(Boolean).join(",");

export const csvUtil = async (response: Response, setLoading?: (loading: boolean) => void) => {
    try {
        const csv = await response.text();
        const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;

        const cd = response.headers.get("Content-Disposition");
        let filename = `transactions-${Date.now()}.csv`;
        if (cd) {
            const match = RegExp(/filename\*?=['"]?(?:UTF-8'')?([^;"']+)/i).exec(cd);
            if (match?.[1]) {
                filename = decodeURIComponent(match[1]);
            }
        }
        a.download = filename;

        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
    } catch (e) {
        console.error(e);
    } finally {
        if (setLoading) setLoading(false);
    }
}